import { Button } from "react-bootstrap";
import constants from "../../helpers/constants";

const FormButtons = (props) => {
    const isDisabled = props.mandatoryFields?.length || props.disabled;

    return (
        <div className="action-btn">
            {(props.hasOwnProperty("handleReset")) &&
                <Button className="btn btn-outline-primary reset-button" onClick={props.handleReset} variant="outline-primary" disabled={props.disabled}>{props.action === constants.DELETE ? "Cancel" : "Reset"}</Button>
            }
            <Button className={`btn btn-primary right-alignement btn-color ${isDisabled ? "disabled" : ""}`} type="submit" onClick={(e) => { props.submitForm(e); }} disabled={isDisabled}>
                {props.action === constants.EDIT ? "Update" : props.action === constants.ADD ? "Save" : props.action === constants.DELETE ? "Delete" : "Submit"}
            </Button>
        </div>
    )

}

export default FormButtons;